import React, { Fragment, useEffect, useState } from 'react';

import {
  useRESTDataCache,
  PlacesProvider,
  ResultProvider,
} from '@atresmedia/elections_modules_library/dist/dataProvider';
import {
  TYPES,
  SUBTYPES,
  ELECTION_SPAIN_GENERAL_EUROPE,
} from '@atresmedia/elections_modules_library/dist/envs';
import AtresBarChart from '@atresmedia/elections_modules_library/dist/components/charts/atresBarChart';
import TableCompare from '@atresmedia/elections_modules_library/dist/components/table';
import Tag from '@atresmedia/elections_modules_library/dist/components/tag';
import Tags from '@atresmedia/elections_modules_library/dist/components/tags';
import ElTabs from '@atresmedia/elections_modules_library/dist/components/elTabs';
import Autocomplete from '@atresmedia/elections_modules_library/dist/components/autocomplete';

import { getRoute, navigateTo } from '../../utils';
import { getSite } from '../moduleGenerator/utils';
import { PROPERTIES_JSON } from '../../core/constants';

const PactosTxt =
  window.location.hostname
    .replace('localhost', 'lasexta')
    .indexOf('lasexta') === -1
    ? 'Pactos'
    : 'Pactómetro';

const InfoTxt = 'DATOS';

const Town = ({
  history,
  communityName,
  onProvinceChange,
  chartType,
  community,
  dataResult,
  electionNumber,
  elSubtype,
  excludes,
  goToDetails,
  placeId,
  province,
  provincePlace,
  reload,
  resultOrigin,
  tabsTitle,
  town,
  townName,
  type,
  year,
}) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  const [rows, setRows] = useState([]);
  const [autocomplePro, setAutocomplePro] = useState('');
  let Chart = AtresBarChart;

  useEffect(() => {
    if (params) {
      const site = getSite();
      setRows(params.sites[site].views.detail.rows);
    }
  }, [params]);

  if (!params || !rows || !provincePlace) {
    return <div>Loading...</div>;
  }

  const totalVotes = Number(dataResult.totalVotes).toLocaleString('de');
  const currentCountPercent = Number(dataResult.currentCountPercent);
  const abstentionVotes = Number(dataResult.abstentionVotes).toLocaleString(
    'de'
  );
  const abstentionPercent = Number(dataResult.abstentionPercent);
  const whiteVotes = Number(dataResult.whiteVotes).toLocaleString('de');
  const whitePercent = Number(dataResult.whitePercent);
  const invalidVotes = Number(dataResult.invalidVotes).toLocaleString('de');
  const invalidPercent = Number(dataResult.invalidPercent);

  const content = rows.map((row) => (
    <div className={row.class}>
      {row.columns.map((column) => (
        <div className={column.class}>
          {column.components.map((item) => {
            return (
              <div className={item.class || ''}>
                {item.module === 'DETAILS_SELECTORS' && (
                  <Fragment>
                    <h2 className="selectedPlaceTitle">
                      <a
                        href={
                          provincePlace &&
                          getRoute(
                            {
                              parentId: community,
                              grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                              name: communityName,
                              path: 'cataluna',
                            },
                            community,
                            excludes,
                            reload,
                            params
                          )
                        }
                        className="selectedCommunityTitle"
                        onClick={(event) => {
                          if (onProvinceChange) {
                            event.preventDefault();
                            return onProvinceChange(
                              null,
                              {
                                parentId: community,
                                grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                              },
                              null,
                              excludes
                            );
                          }
                        }}
                      >
                        {communityName}
                      </a>

                      <a
                        href={
                          provincePlace &&
                          getRoute(
                            provincePlace,
                            community,
                            excludes,
                            reload,
                            params
                          )
                        }
                        className="selectedTownTitle"
                        onClick={(event) => {
                          if (onProvinceChange) {
                            event.preventDefault();
                            return onProvinceChange(
                              null,
                              provincePlace,
                              null,
                              excludes
                            );
                          }
                        }}
                      >
                        {provincePlace.name}
                      </a>
                    </h2>
                    <div className="selectors_container">
                      <h3 class="town-title">{townName}</h3>

                      <PlacesProvider
                        // name={autocomplePro}
                        type="TOWN"
                        sortby="name"
                        parentId={province}
                        grandParentId={province ? undefined : community}
                      >
                        {(data) => {
                          return (
                            <Autocomplete
                              results={[
                                ...data.filter((d) => {
                                  return autocomplePro
                                    ? d.name
                                        .toLocaleLowerCase()
                                        .includes(
                                          autocomplePro.toLocaleLowerCase()
                                        )
                                    : d;
                                }),
                              ]}
                              onChange={(value) => setAutocomplePro(value)}
                              onSelect={(select) => {
                                if (onProvinceChange)
                                  return onProvinceChange(
                                    null,
                                    select,
                                    null,
                                    excludes
                                  );

                                navigateTo(
                                  history,
                                  reload,
                                  `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.grandpaId}/${select.parentId}/${select.ineId}/resultados.html`,
                                  select,
                                  true,
                                  excludes,
                                  params
                                );
                                setAutocomplePro('');
                              }}
                              placeholder={'Busque municipio'}
                              showArrow
                              defaultValue={data.length > 0 && town}
                            />
                          );
                        }}
                      </PlacesProvider>
                    </div>
                  </Fragment>
                )}
                {item.module === 'SEAT_DETAILS' && (
                  <Fragment>
                    <table className="infoTable">
                      <tbody>
                        <tr>
                          <td className="key">Votos contabilizados: </td>
                          <td className="value votes">
                            {isNaN(totalVotes) ? 'Cargando...' : totalVotes}
                          </td>
                          <td className="value votes_percent">
                            {isNaN(currentCountPercent)
                              ? 'Cargando...'
                              : currentCountPercent.toLocaleString('de') + '%'}
                          </td>
                        </tr>
                        <tr>
                          <td className="key">Abstenciones: </td>
                          <td className="value votes">
                            {isNaN(abstentionVotes)
                              ? 'Cargando...'
                              : abstentionVotes}
                          </td>
                          <td className="value abstention_percent">
                            {isNaN(abstentionPercent)
                              ? 'Cargando...'
                              : abstentionPercent.toLocaleString('de') + '%'}
                          </td>
                        </tr>
                        <tr>
                          <td className="key">Votos en blanco: </td>
                          <td className="value whites">
                            {isNaN(whiteVotes) ? 'Cargando...' : whiteVotes}
                          </td>
                          <td className="value whites_percent">
                            {isNaN(whitePercent)
                              ? 'Cargando...'
                              : whitePercent.toLocaleString('de') + '%'}
                          </td>
                        </tr>
                        <tr>
                          <td className="key">Votos nulos: </td>
                          <td className="value null">
                            {isNaN(invalidVotes) ? 'Cargando...' : invalidVotes}
                          </td>
                          <td className="value null_percent">
                            {isNaN(invalidPercent)
                              ? 'Cargando...'
                              : invalidPercent.toLocaleString('de') + '%'}
                          </td>
                        </tr>
                        {dataResult.totalSeats > 0 && (
                          <tr>
                            <td className="key">Total de escaños: </td>
                            <td className="value votes">
                              {Number(dataResult.totalSeats).toLocaleString(
                                'de'
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Fragment>
                )}
                {item.module === 'BACK' && (
                  <p className="buttonBackContainer">
                    <a
                      href={
                        provincePlace &&
                        getRoute(
                          provincePlace,
                          community,
                          excludes,
                          reload,
                          params
                        )
                      }
                      type="button"
                      className="tag button current"
                      onClick={(event) => {
                        if (onProvinceChange) {
                          event.preventDefault();
                          return onProvinceChange(
                            null,
                            provincePlace,
                            null,
                            excludes
                          );
                        }
                      }}
                    >
                      Volver
                    </a>
                  </p>
                )}
                {item.module === 'RESULTADOS' && (
                  <div className="detail-bar-chart">
                    <AtresBarChart
                      data={dataResult.partiesResult || []}
                      dataKey={town ? 'votesPercent' : 'seats'}
                      isSenate={elSubtype === SUBTYPES.SENATE}
                      showMajorityLine={
                        type !== TYPES.REGIONAL
                          ? !province && !community
                          : !Boolean(province)
                      }
                      slice={8}
                      showLabel
                      unitLabel={town ? 'votos' : null}
                      labelAbrv=""
                      seatTotal={dataResult.totalVotes || 0}
                    />
                  </div>
                )}
                {item.module === 'TABS_CONTAINER' && (
                  <ElTabs titles={item.data.tabs.map((tab) => tab.title)}>
                    {item.data.tabs.map((tab) => {
                      return (
                        <ResultProvider
                          active={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.active
                          }
                          year={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.year
                          }
                          type={type}
                          subtype={elSubtype}
                          electionPlace={placeId}
                          electionNumber={
                            resultOrigin &&
                            resultOrigin.historic &&
                            resultOrigin.historic.numElection
                          }
                          placeId={town || province || community}
                        >
                          {(oldData) => {
                            return (
                              <Fragment>
                                {tab.component === 'TABLE' && (
                                  <TableCompare
                                    className="current"
                                    data={dataResult.partiesResult || []}
                                    details={
                                      elSubtype === SUBTYPES.CONGRESS ||
                                      type === TYPES.REGIONAL
                                    }
                                    isSenate={elSubtype === SUBTYPES.SENATE}
                                    hideSeats={town}
                                  />
                                )}
                                {tab.component === 'RESULTADOS' && (
                                  <div>
                                    <div className="detail-bar-chart">
                                      <Chart
                                        data={
                                          (tab.data.year === params.year
                                            ? dataResult.partiesResult
                                            : oldData.partiesResult) || []
                                        }
                                        slice={8}
                                        dataKey={'votesPercent'}
                                        isSenate={elSubtype === SUBTYPES.SENATE}
                                        showMajorityLine={
                                          type !== TYPES.REGIONAL
                                            ? !province && !community
                                            : !Boolean(province)
                                        }
                                        showLabel
                                        labelAbrv=""
                                        seatTotal={dataResult.totalSeats || 0}
                                        unitLabel={null}
                                      />
                                    </div>
                                  </div>
                                )}
                              </Fragment>
                            );
                          }}
                        </ResultProvider>
                      );
                    })}
                  </ElTabs>
                )}
                {item.module === 'TAGS' && (
                  <Fragment>
                    <p className="tags-title">
                      Resultado de las elecciones catalanas en:
                    </p>
                    <Tags>
                      <PlacesProvider
                        type="TOWN"
                        grandParentId={!province ? community : null}
                        parentId={province || community}
                        size={10}
                        sortby="main"
                      >
                        {(data) =>
                          data &&
                          data.slice(0, 10).map((d) => (
                            <Tag
                              key={`${d.ineId}-${d.name}`}
                              onClick={(event) => {
                                event.preventDefault();
                                goToDetails(d, event);
                              }}
                              native
                              route={getRoute(
                                d,
                                true,
                                excludes,
                                reload,
                                params
                              )}
                            >
                              {d.name}
                            </Tag>
                          ))
                        }
                      </PlacesProvider>
                    </Tags>
                  </Fragment>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  ));
  return (
    <Fragment>
      <div className="page-detail">{content}</div>
    </Fragment>
  );
};

export default Town;
